<template>
	<table class="table table-striped limit table-responsive-xl">
		<thead>
		<th width="20">ID</th>
		<th>Логiн</th>
		<th>Пароль</th>
		<th width="40">Права</th>
		<th width="10"></th>
		<th width="10"></th>
		</thead>
		<tbody>
		<tr v-for="user in users">
			<td>
				{{user.id}}
			</td>
			<td>
				{{user.user_name}}
			</td>
			<td>
				{{user.pass}}
			</td>
			<td>
				{{user.userright}}
			</td>
			<td>
				<i class="fal fa-edit edit_exchange_user" v-on:click="edit_user(user)"></i>
			</td>

			<th>
				<i class="fa fa-times remove_exchange_user" v-on:click="remove_user(user)"></i>
			</th>
		</tr>
		</tbody>
	</table>
</template>

<script>
export default {
	name: "f_users_table",
	props : {
		users : {
			type : Array
		},
		user_id : {
			type : Number,
			require : true
		}
	},
	methods : {
		edit_user(user) {
			EventBus.$emit('edit_exchange_user',user);
		},

		async remove_user(user) {
			await api.delete('/user/' + this.user_id + "/file_exchange/users/" + user.id).then(({data}) => {
				if(data.status === "operation_success") {
					EventBus.$emit('reload_exchange_users');
				}
			}).catch(({response}) => {
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
			});
		},
	}
}
</script>

<style scoped>

</style>
